import { createContext, useContext, useState } from "react";

export const ControlContext = createContext();

export const ControlProvider = ({ children }) => {
  const [canInputCNP, setCanInputCNP] = useState(true);
  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [hiddenFormCustomer, setHiddenFormCustomer] = useState(true);

  const [progressViewerCustomer, setProgressViewerCustomer] = useState(false);
  const [progressViewerEmail, setProgressViewerEmail] = useState(false);
  const [progressViewerPayment, setProgressViewerPayment] = useState(false);

  const [activeStepOne, setActiveStepOne] = useState(true);
  const [activeStepTwo, setActiveStepTwo] = useState(false);
  const [activeStepThree, setActiveStepThree] = useState(false);

  const [activeFormEmail, setActiveFormEmail] = useState(true);
  const [activeFormPhone, setActiveFormPhone] = useState(false);
  const [activeFormPaymentMethod, setActiveFormPaymentMethod] = useState(false);

  const [backEndVersion, setBackEndVersion] = useState("0.0.0");

  const showFormCustomer = (value) => {
    setHiddenFormCustomer(!value);
  };

  const enableFormTwo = () => {
    setActiveStepTwo(true);
    setActiveStepOne(false);
    setActiveStepThree(false);
  };

  const enableFormThree = () => {
    setActiveStepTwo(false);
    setActiveStepOne(false);
    setActiveStepThree(true);
  };

  return (
    <ControlContext.Provider
      value={{
        hiddenFormCustomer,
        showFormCustomer,
        progressViewerCustomer,
        setProgressViewerCustomer,
        progressViewerEmail,
        setProgressViewerEmail,
        progressViewerPayment,
        setProgressViewerPayment,
        activeStepOne,
        activeStepTwo,
        activeStepThree,
        enableFormTwo,
        enableFormThree,
        canInputCNP,
        setCanInputCNP,
        activeFormEmail,
        setActiveFormEmail,
        activeFormPhone,
        setActiveFormPhone,
        activeFormPaymentMethod,
        setActiveFormPaymentMethod,
        isNewCustomer,
        setIsNewCustomer,
        backEndVersion,
        setBackEndVersion,
      }}
    >
      {children}
    </ControlContext.Provider>
  );
};

export const useControlContext = () => {
  return useContext(ControlContext);
}

